import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealersService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveDealerDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/company/dealer';
    return this.http.post(url, payload);
  }

  getDealerDetails(filterObj?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/company/dealers';
    return this.http.get(url,{params:filterObj});
  }

  updateDealerDetails(dealerId:string, payload:any): Observable<any>{
    let url = environment.BASE_URL + `/v1/company/dealer/${dealerId}`;
    return this.http.put(url,payload);
  }

  getDealerDetailsByDealerId(dealerId:string): Observable<any>{
    let url = environment.BASE_URL + `/v1/company/dealer/${dealerId}`;
    return this.http.get(url);
  }
}
